import React from 'react';
import { observer } from 'mobx-react';
import SubscriptionCard from '../../components/subscriptionCard';
import useSubscriptionCard from '../../../store/models/subscriptions/useSubscriptionCard';

const SubscriptionCardContainer = observer(function SubscriptionCardContainer({
    subscription,
    onUnsubscribe,
    onRemoveSchedule,
    onAddSchedule,
}) {
    const { connectedSchedules, availableSchedules, details } = useSubscriptionCard(subscription.id);

    return (
        <SubscriptionCard
            subscriptionId={subscription.id}
            publisher={details.publisher}
            app={details.app}
            timezone={details.timezone}
            lastSyncedLabel={details.lastSyncedLabel}
            isActive={details.isActive}
            connectedSchedules={connectedSchedules}
            availableSchedules={availableSchedules}
            onUnsubscribe={onUnsubscribe}
            onRemoveSchedule={onRemoveSchedule}
            onAddSchedule={onAddSchedule}
        />
    );
});

export default SubscriptionCardContainer;
